import type { StateCreator } from 'zustand';
import { initializeTabs, setActiveTabById, setActiveTabIndex } from './actions';
import type { PatientTabsSliceType } from './types';

export const patientTabsSlice: StateCreator<
  PatientTabsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  PatientTabsSliceType
> = (set, get, store) => ({
  patientTabs: { activeTabIndex: 0, tabs: [] },
  setActiveTabIndex: (index) => setActiveTabIndex(set, get, store)(index),
  setActiveTabById: (id) => setActiveTabById(set, get, store)(id),
  initializeTabs: (tabs, initialTabId) => initializeTabs(set, get, store)(tabs, initialTabId),
});
